<ng-container *ngIf="params.value && activatedRoute != 'project-report-setting'">
  <div *ngIf="activatedRoute == 'admin-roles'">
    <a
      *ngIf="params.data.name != 'Super Admin'"
      id="resendMail"
      [title]="clickTooltipDef"
      href="javascript:void(0)"
      style="cursor: pointer"
      (click)="routeToRoleDetail(params.data.idStr, params?.organizationId)"
      class="nameStatus"
      >{{ params.data.name }}</a
    >
    <span *ngIf="params.data.name == 'Super Admin'" href="javascript:void(0)" id="superAdmin">{{
      params.data.name
    }}</span>
  </div>
  <div *ngIf="activatedRoute == 'roles'">
    <a
      *ngIf="params.data.name != 'Super Admin'"
      id="resendMail"
      [title]="clickTooltipDef"
      href="javascript:void(0)"
      style="cursor: pointer"
      (click)="routeToRoleDetail(params.data.idStr)"
      class="nameStatus"
      >{{ params.data.name }}</a
    >
    <span *ngIf="params.data.name == 'Super Admin'" href="javascript:void(0)" id="superAdmin">{{
      params.data.name
    }}</span>
  </div>
  <a
    *ngIf="params.colDef.headerName == 'Scenario name'"
    id="resendMail"
    href="javascript:void(0)"
    [title]="dblClickTooltipDef"
    style="cursor: pointer"
    (dblclick)="routeToPath()"
    class="nameStatus"
    >{{ params.data.name }}</a
  >
  <a
    *ngIf="params.colDef.headerName == 'Product name'"
    id="resendMail"
    href="javascript:void(0)"
    [title]="dblClickTooltipDef"
    style="cursor: pointer"
    (dblclick)="routeToProductPath()"
    class="nameStatus"
    >{{ params.data.productName }}</a
  >
</ng-container>

<ng-container *ngIf="params.value && activatedRoute == 'project-report-setting'">
  <a
    href="javascript:void(0)"
    style="cursor: pointer"
    id="resendMail"
    [title]="clickTooltipDef"
    (click)="routeToEdit()"
    class="nameStatus"
    >{{ params.data.name }}</a
  >
</ng-container>
